import axios from 'axios';

// Always use relative path for API - works in all environments
const API = '/api';

// Time Entries API
export const timeEntriesApi = {
  create: (data) => axios.post(`${API}/time-entries`, data),
  getAll: (payPeriodStart) => {
    const params = payPeriodStart ? { pay_period_start: payPeriodStart } : {};
    return axios.get(`${API}/time-entries`, { params });
  },
  getOne: (id) => axios.get(`${API}/time-entries/${id}`),
  update: (id, data) => axios.put(`${API}/time-entries/${id}`, data),
  delete: (id) => axios.delete(`${API}/time-entries/${id}`),
};

// Commissions API
export const commissionsApi = {
  create: (data) => axios.post(`${API}/commissions`, data),
  getAll: (payPeriodStart) => {
    const params = payPeriodStart ? { pay_period_start: payPeriodStart } : {};
    return axios.get(`${API}/commissions`, { params });
  },
  getOne: (id) => axios.get(`${API}/commissions/${id}`),
  update: (id, data) => axios.put(`${API}/commissions/${id}`, data),
  delete: (id) => axios.delete(`${API}/commissions/${id}`),
};

// Pay Periods API
export const payPeriodsApi = {
  getAll: () => axios.get(`${API}/pay-periods`),
  getCurrent: () => axios.get(`${API}/pay-periods/current`),
};

// Admin API
export const adminApi = {
  getUsers: () => axios.get(`${API}/admin/users`),
  createUser: (data) => axios.post(`${API}/admin/users`, data),
  toggleUserActive: (userId) => axios.put(`${API}/admin/users/${userId}/toggle-active`),
  updateHourlyRate: (userId, hourlyRate) => axios.put(`${API}/admin/users/${userId}/hourly-rate`, { hourly_rate: hourlyRate }),
  deleteUser: (userId) => axios.delete(`${API}/admin/users/${userId}`),
  
  getTimeEntries: (filters = {}) => {
    const params = {};
    if (filters.startDate) params.start_date = filters.startDate;
    if (filters.endDate) params.end_date = filters.endDate;
    if (filters.payPeriodStart) params.pay_period_start = filters.payPeriodStart;
    if (filters.status) params.status = filters.status;
    if (filters.userId) params.user_id = filters.userId;
    return axios.get(`${API}/admin/time-entries`, { params });
  },
  
  actionOnEntry: (entryId, action) => 
    axios.put(`${API}/admin/time-entries/${entryId}/action`, { action }),
  
  bulkAction: (entryIds, action) => 
    axios.put(`${API}/admin/time-entries/bulk-action`, null, { 
      params: { entry_ids: entryIds.join(','), action } 
    }),
  
  // Commission admin endpoints
  getCommissions: (filters = {}) => {
    const params = {};
    if (filters.payPeriodStart) params.pay_period_start = filters.payPeriodStart;
    if (filters.status) params.status = filters.status;
    if (filters.userId) params.user_id = filters.userId;
    return axios.get(`${API}/admin/commissions`, { params });
  },
  
  actionOnCommission: (commissionId, action) => 
    axios.put(`${API}/admin/commissions/${commissionId}/action`, { action }),
  
  bulkCommissionAction: (commissionIds, action) => 
    axios.put(`${API}/admin/commissions/bulk-action`, null, { 
      params: { commission_ids: commissionIds.join(','), action } 
    }),
  
  exportCommissions: (payPeriodStart) => 
    axios.get(`${API}/admin/export-commissions`, { 
      params: { pay_period_start: payPeriodStart },
      responseType: 'blob'
    }),
  
  getStats: () => axios.get(`${API}/admin/stats`),
  
  exportPayPeriod: (payPeriodStart) => 
    axios.get(`${API}/admin/export`, { 
      params: { pay_period_start: payPeriodStart },
      responseType: 'blob'
    }),
};

// Helper to format dates
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { 
    weekday: 'short', 
    month: 'short', 
    day: 'numeric' 
  });
};

export const formatDateRange = (start, end) => {
  const startDate = new Date(start);
  const endDate = new Date(end);
  return `${startDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - ${endDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`;
};
